import Flex from 'antd/es/flex';
import Text from 'antd/es/typography/Text';
import { FC, ReactNode } from 'react';
import styles from './List.module.css';

interface ItemProps {
  title: string;
  value: string;
  strong?: boolean;
}

const List: FC<{
  children: ReactNode[] | ReactNode;
}> & {
  Item: FC<ItemProps>;
} = ({ children }) => {
  return (
    <Flex vertical className={styles.list}>
      {children}
    </Flex>
  );
};

const Item: FC<ItemProps> = ({ title, value, strong = false }) => {
  return (
    <Flex justify="space-between">
      <Text strong={strong}>{title}</Text>
      <Text strong>{value}</Text>
    </Flex>
  );
};

List.Item = Item;

export default List;
